import { APPTOOLS_DOC, PERSONAL_APPTOOLS_DOC_PREFIX } from '@awwyeah/shared';
import type { WebModule } from '../registry';
import { AppsIndexPage } from './AppsIndexPage';
import { NotePadPage } from './NotePadPage';
import { SketchPadPage } from './SketchPadPage';

/**
 * Apps tab (client side, WS-16): NotePad + SketchPad, built on the WS-15 sharing
 * foundation. Registry/audience shape mirrors `lists` exactly — see
 * `useAppToolRegistries.ts`'s doc comment and docs/DECISIONS.md 2026-08-02.
 */
export const appsWebModule: WebModule = {
  id: 'apps',
  // No tab since 2026-11-03: notes, sketches and trackers are experiments, reached from
  // Settings → "Apps & experiments".
  routes: [
    { path: '/apps', component: AppsIndexPage },
    { path: '/apps/note/:toolId', component: NotePadPage },
    { path: '/apps/sketch/:toolId', component: SketchPadPage },
  ],
  docs: [APPTOOLS_DOC, PERSONAL_APPTOOLS_DOC_PREFIX, 'note:', 'sketch:'],
};
